export enum SowState {
    Dry = 'Dry',
    Pregnant = 'Pregnant',
    Nursing = 'Nursing',
    PregnantAndNursing = 'PregnantAndNursing'
}
